import { useEffect, useState } from "react";
import ParticipantOverviewTable from "./participantOverviewTable";
import ParticipantDetails from "./participantDetails";
import useParticipantOverviewService from "../services/participantOverviewService";
import Backdrop from "@mui/material/Backdrop";
import ActionButton from "./actionButton";
import Alert from '@mui/material/Alert';
import { Typography, Box } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";

const Participant = () => {
  const {
    participantsData,
    isLoadingParticipants,
    participantsServerError,
    queryparticipants,
    nextParticipants,
    nextToken
  } = useParticipantOverviewService();
  const [participant, setParticipant] = useState(null);
  const [showAlert, setShowAlert] = useState(true);

  const closeDialog = () => {
    setParticipant(null);
  };

  useEffect(() => {
    setShowAlert(true);
  }, [isLoadingParticipants, setShowAlert]);

  const nextPart = () => {
    if (participantsData && nextToken) {
      nextParticipants();
    } else {
      queryparticipants();
    }
  };

  let buttonText = "Ophalen deelnemers"
  if (participantsData) {
      if (nextToken) {
          buttonText = "Volgende deel ophalen"
      } else {
        buttonText = "Ververs lijst"
      }

  }


  return (
    <Box id="DeelnemersListBox" sx={{ minHeight: '200px' , paddingTop: '6px'}}>
      {/*<Typography variant="h5" align="center" color="textSecondary">
        Deelnemers overzicht
      </Typography>*/}

      <ActionButton
        color="primary"
        size="small"
        id="NextPartParticipants"
        sx={{ width: '250px', marginBottom: '8px' }}
        onClick={nextPart}
      >
        {buttonText} 
      </ActionButton>
      {participantsData && <ParticipantOverviewTable
        participants={participantsData}
        nextPart={nextPart}
        currentState="done"
      />}
      {participant && (
        <ParticipantDetails participant={participant} close={closeDialog} />
      )}
      {participantsServerError && showAlert && (
        <Alert
          onClose={() => {
            setShowAlert(false);
          }}
          severity="error"
        >
          {participantsServerError}
        </Alert>
      )}
      <Backdrop 
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoadingParticipants}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
};

export default Participant;
